function splitRoles(value) {
  if (typeof value !== 'string') return [];
  return value
    .split(/[\s,;|/\\]+/)
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean);
}

function pushRole(acc, raw) {
  if (raw == null) return;
  if (typeof raw === 'string') {
    const exploded = splitRoles(raw);
    if (exploded.length) {
      acc.push(...exploded);
      return;
    }
    const normalized = raw.trim().toLowerCase();
    if (normalized) acc.push(normalized);
    return;
  }
  const normalized = String(raw).trim().toLowerCase();
  if (normalized) acc.push(normalized);
}

export function collectRoles(entity) {
  if (!entity) return [];
  const bucket = [];
  if (Array.isArray(entity)) {
    entity.forEach((value) => pushRole(bucket, value));
  } else if (typeof entity === 'string') {
    pushRole(bucket, entity);
  } else {
    if (typeof entity.role === 'string' && entity.role.trim()) {
      pushRole(bucket, entity.role);
    }
    const rawRoles = entity.roles;
    if (Array.isArray(rawRoles)) {
      rawRoles.forEach((value) => pushRole(bucket, value));
    } else if (typeof rawRoles === 'string') {
      pushRole(bucket, rawRoles);
    } else if (rawRoles && typeof rawRoles === 'object') {
      Object.entries(rawRoles).forEach(([key, value]) => {
        if (value === false || value == null) return;
        // allow truthy booleans or explicit string values
        if (typeof value === 'string') pushRole(bucket, value);
        else pushRole(bucket, key);
      });
    }
  }
  return Array.from(new Set(bucket));
}

export function hasRole(entity, role) {
  if (!role) return false;
  const target = String(role).trim().toLowerCase();
  if (!target) return false;
  return collectRoles(entity).includes(target);
}
